//FireBase
var config = {
  apiKey: "AIzaSyBrNKldywUjnzBwK21zCMdLppgZP2cMIFQ",
  authDomain: "ashram-50f62.firebaseapp.com",
  databaseURL: "https://ashram-50f62.firebaseio.com",
  projectId: "ashram-50f62",
  storageBucket: "ashram-50f62.appspot.com",
  messagingSenderId: "533414254902",
  appId: "1:533414254902:web:e38643908c9b60e2"
};
  
exports.config = config;



// WEBPACK FOOTER //
// ./src/config/firebase_config.js